import * as T from "../constants";

const suggestedMailingAddressReducer = (state = "", action) => {
    const { type } = action;

    switch (type) {
        case T.SUGGESTED_MAILING_ADDRESS_REQUESTED_SUCCESS:
            return action.payload
            
        case T.SUGGESTED_MAILING_ADDRESS_REQUESTED_FAIL:
            return action.payload
            
        default:
            return state;
    }
}

export default suggestedMailingAddressReducer;